import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AnnouncementWrapper } from '../AnnouncementWrapper'
import { ProgramsBanner } from './ProgramsBanner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export const EnterpriseAnnouncementBanner = () => (
  <QueryClientProvider client={queryClient}>
    <AnnouncementWrapper>
      <ProgramsBanner />
    </AnnouncementWrapper>
  </QueryClientProvider>
)
